import { LANG_CODES_TO_TLD } from "../general_utils"

// types
import { SingleHrefLangMetaDataSet } from "../../../gatsby-node"

export const staticHrefLangTags: (
  path: string
) => SingleHrefLangMetaDataSet[] = (path: string) => {
  return Object.keys(LANG_CODES_TO_TLD).map((langCode) => {
    const lowerCasedLocale = langCode?.toLowerCase()
    const tld = LANG_CODES_TO_TLD[lowerCasedLocale]
    const beginPathHandle = path?.startsWith("/") ? path : `/${path}`
    const handledPath = beginPathHandle?.endsWith("/")
      ? beginPathHandle
      : `${beginPathHandle}/`

    return {
      rel: "alternate",
      hreflang: lowerCasedLocale,
      href: `https://www.${process.env.GATSBY_BASE_HOST_NAME?.replace(
        ".com",
        ""
      )?.trim()}${tld}/help/${lowerCasedLocale}${handledPath}`
    }
  })
}
